export const AppConfig = {
  site_name: "Kosmo.Delivery",
  title: "Kosmo.Delivery",
  description: "Kosmo Delivery API as a Service",
  locale: "en",
}
export default AppConfig
